import React, { useEffect, useState } from 'react';

import styles from './DogCardBreedingOverview.module.scss';
import { useTranslate } from 'react-polyglot';
import { useAuth } from '../../../../../../Auth';
import { useAxios } from '../../../../../../AxiosHandler';
import Card from '../../../../../Shared/Card/Card';
import StatusDot from '../../../../../Shared/StatusDot/StatusDot';
import { general } from '../../../../../../general';
import { Form } from 'react-bootstrap';

function DogCardBreedingOverview(props: DogCardBreedingOverviewProps) {
    const t = useTranslate();
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [data, setData] = useState<any>("loading ..");
    const [dataBreedingApproved, setBreedingApprovedData] = useState<any>("loading ..");

    const [loading, setLoading] = useState<boolean>(true);

    // From the former Slektskap card, merged into this one
    const [dataPups, setPupsData] = useState<any>();
    const [prizedSiblings, setPrizedSiblings] = useState<any>();

    function mapCountToStatusDot(count: any) {
        if (props.statusDisabled) return null;
        if (count == "loading ..") return <StatusDot color="grey" size='md' />;

        if (typeof count == "string") return <StatusDot color="grey" size='md' />;
        if (count < 20) return <StatusDot color="#68db5a" size='md' />;
        if (count >= 20) return <StatusDot color="#ff2f45" size='md' />;
    }

    function getPupsData() {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/dog/" + props.dogId + "/pupscount",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            setPupsData(res.data);
        }).catch((err: any) => {
            console.log(err);
        });
    }

    function getPrizedSiblingsData() {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/dog/" + props.dogId + "/prizedsiblings",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            setPrizedSiblings(res.data);
        }).catch((err: any) => {
            console.log(err);
        });
    }

    function mapBreedingApprovedToStatusDot(status: string) {
        if (props.statusDisabled) return null;
        if (status == "loading ..") return <StatusDot color="grey" size='md' />;

        if (typeof status == "string") return <StatusDot color="grey" size='md' />;
        if (status === 1) return <StatusDot color="#68db5a" size='md' />;
        if (status === 0) return <StatusDot color="#ff2f45" size='md' />;
    }
    
    function getBreedingApprovedData() {
        if (auth.selectedBreed == undefined) return;
        setLoading(true);
        axios.single({
            method: 'post',
            url: "/api/statistics/dog/" + props.dogId + "/health/breedingapproved",
            responseType: 'json',
            data: {},
            headers: {
                'x-access-token': auth.user['token'],
                "selected-country": auth.selectedCountry || "all",
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': '0',
            }
        }).then((res) => {
            if (res.data != undefined) {
                setBreedingApprovedData(res.data || t("dog.statistics.not_tested"));
                props.onDataLoaded?.(res.data);
                setLoading(false);
            }
        }).catch((err: any) => {
            console.log(err);
        });
    }

    function toggleBreedingApproved(approved: number) {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'put',
            url: "/api/statistics/dog/" + props.dogId + "/health/breedingapproved",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" },
            data: {
                breedingapproved: approved == 1 ? 0 : 1
            }
        }).then((res) => {
            getBreedingApprovedData();
        }).catch((err: any) => {
            console.log(err);
        });
    }

    function toggleBreedingApprovedPublic(approved: string) {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'post',
            url: "/api/statistics/dog/" + props.dogId + "/health/breedingapprovedpublish",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" },
            data: {
                publish_public: approved
            }
        }).then((res) => {
            getBreedingApprovedData();
        }).catch((err: any) => {
            console.log(err);
        });
    }

    function toggleOnWait(onWait: number) {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'put',
            url: "/api/statistics/dog/" + props.dogId + "/health/onwait",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" },
            data: {
                on_wait: onWait == 1 ? 0 : 1
            }
        }).then((res) => {
            getBreedingApprovedData();
        }).catch((err: any) => {
            console.log(err);
        });
    }

    useEffect(() => {
        if (props.dogId != undefined) {
            //getBreedingData();
            getBreedingApprovedData();
            getPupsData();
            getPrizedSiblingsData();
        }
    }, [props.dogId, auth.selectedBreed]);

    return (
        <div className={styles.breedingoverview}>
            <Card
                title={props.title || "Breeding Overview"}
                children={<div>
                    <hr/>
                    <table className={styles.breedingtable}>
                        <tbody>
                            <tr>
                                <td><strong>{t("dog.statistics.pups.title")}:</strong></td>
                                <td><span style={{marginRight: "6px"}}>{dataPups}</span>{mapCountToStatusDot(dataPups)}</td>
                            </tr>
                            <tr>
                                <td><strong>{t("dog.statistics.siblings.prized")}:</strong></td>
                                <td><span style={{marginRight: "6px"}}>{prizedSiblings}</span>{mapCountToStatusDot(prizedSiblings)}</td>
                            </tr>
                        </tbody>
                    </table>
                    <hr/>
                    <div className={styles.subtitle}><strong>{t("dog.details.breeding.status")}:</strong></div>
                    <table className={styles.breedingtable}>
                        <tbody>
                            <tr>
                                <td><strong>{t("dog.details.breeding.approved")}:</strong></td>
                                <td>
                                    {!loading ?
                                        <>
                                            <span style={{marginRight: "6px"}}>
                                                {dataBreedingApproved?.APPROVED == 1 ?
                                                    `${t("dog.details.health.breedingapproved.true")} (${dataBreedingApproved?.COUNCIL_NAME})`
                                                :
                                                    t("dog.details.health.breedingapproved.false")
                                                }
                                            </span>
                                            {mapBreedingApprovedToStatusDot(dataBreedingApproved?.APPROVED)}
                                            {general.getBreedAccess(auth.user, auth.selectedBreed) == "admin" ? 
                                                <button
                                                    className={styles.editButton}
                                                    onClick={() => {
                                                        toggleBreedingApproved(dataBreedingApproved?.APPROVED);
                                                    }}
                                                >{dataBreedingApproved?.APPROVED ?
                                                    t("dog.details.health.breedingapproved.disapprove")
                                                :
                                                    t("dog.details.health.breedingapproved.approve")
                                                }</button>
                                            : null}
                                        </>
                                    :
                                        <>
                                            <span style={{marginRight: "6px"}}>
                                                {t("dog.details.loading")}
                                            </span>
                                        </>
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td><strong>{t("dog.details.breeding.published")}:</strong></td>
                                <td>
                                    {!loading ?
                                        <>
                                            {auth.selectedBreed == "145" ?
                                                <>
                                                    <Form.Control
                                                        as="select"
                                                        value={dataBreedingApproved?.PUBLISHED_PUBLIC}
                                                        onChange={(e: any) => {
                                                            toggleBreedingApprovedPublic(e.target.value);
                                                        }}
                                                    >
                                                        <option value="0">{t("dog.details.health.breedingpublished.false")}</option>
                                                        <option value="1">{t("dog.details.health.breedingpublished.both")}</option>
                                                        <option value="leash">{t("dog.details.health.breedingpublished.leash")}</option>
                                                        <option value="loose">{t("dog.details.health.breedingpublished.loose")}</option>
                                                    </Form.Control>
                                                </>
                                            :
                                                <>
                                                    <span style={{marginRight: "6px"}}>
                                                        {dataBreedingApproved?.PUBLISHED_PUBLIC != "0" && dataBreedingApproved?.PUBLISHED_PUBLIC != null ?
                                                            `${t("dog.details.health.breedingpublished.true")}`
                                                        :
                                                            t("dog.details.health.breedingpublished.false")
                                                        }
                                                    </span>
                                                    {mapBreedingApprovedToStatusDot(dataBreedingApproved?.PUBLISHED_PUBLIC)}
                                                    {general.getBreedAccess(auth.user, auth.selectedBreed) == "admin" ? 
                                                        <button
                                                            className={styles.editButton}
                                                            onClick={() => {
                                                                toggleBreedingApprovedPublic(dataBreedingApproved?.PUBLISHED_PUBLIC == "1" ? "0" : "1");
                                                            }}
                                                        >{dataBreedingApproved?.PUBLISHED_PUBLIC != "0" && dataBreedingApproved?.PUBLISHED_PUBLIC != null ?
                                                            t("dog.details.health.breedingpublished.unpublish")
                                                        :
                                                            t("dog.details.health.breedingpublished.publish")
                                                        }</button>
                                                    : null}
                                                </>
                                            }
                                        </>
                                    :
                                        <>
                                            <span style={{marginRight: "6px"}}>
                                                {t("dog.details.loading")}
                                            </span>
                                        </>
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td><strong>{t("dog.details.breeding.onwait")}:</strong></td>
                                <td>
                                    {!loading ?
                                        <>
                                            <span style={{marginRight: "6px"}}>
                                                {dataBreedingApproved?.ON_WAIT == 1 ?
                                                    t("dog.details.health.onwait.true")
                                                :
                                                    t("dog.details.health.onwait.false")
                                                }
                                            </span>
                                            {mapBreedingApprovedToStatusDot(dataBreedingApproved?.ON_WAIT)}
                                            {general.getBreedAccess(auth.user, auth.selectedBreed) == "admin" ? 
                                                <button
                                                    className={styles.editButton}
                                                    onClick={() => {
                                                        toggleOnWait(dataBreedingApproved?.ON_WAIT);
                                                    }}
                                                >{dataBreedingApproved?.ON_WAIT == 1 ?
                                                    t("dog.details.health.onwait.remove")
                                                :
                                                    t("dog.details.health.onwait.set")
                                                }</button>
                                            : null}
                                        </>
                                    :
                                        <>
                                            <span style={{marginRight: "6px"}}>
                                                {t("dog.details.loading")}
                                            </span>
                                        </>
                                    }
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>}
            ></Card>
        </div>
    );
}

class DogCardBreedingOverviewProps {
    title?: string;
    dogId!: string | undefined;
    statusDisabled?: boolean;
    onDataLoaded?: (data: any) => void;
}

export default DogCardBreedingOverview;